<template>
<el-row class="container">
  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text">{{sysUserName}}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="handleUpdatePassword">修改密码</el-dropdown-item>
      <el-dropdown-item @click.native="logOff">退出登录
        <!-- <d2-icon name="power-off" class="d2-mr-5"/> -->
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  <!-- 设置密码界面 start -->
    <el-dialog title="修改密码" :visible.sync="editPasswordFormVisible" :close-on-click-modal="false">
      <el-row>
        <el-col :span="16">
          <el-form
            :model="editPasswordForm"
            label-width="120px"
            :rules="editPasswordFormRules"
            ref="editPasswordForm"
          >
            <el-form-item label="旧密码" prop="oldPassword">
              <el-input :type="showPass?'text':'password'" v-model.trim="editPasswordForm.oldPassword" auto-complete="off">
                <el-button slot="append" :icon="showPass?'el-icon-more':'el-icon-view'" @click="showPass = !showPass"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password">
              <el-input :type="showPass?'text':'password'" v-model.trim="editPasswordForm.password" auto-complete="off">
                <el-button slot="append" :icon="showPass?'el-icon-more':'el-icon-view'" @click="showPass = !showPass"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label="重复新密码" prop="rePassword">
              <el-input :type="showPass?'text':'password'" v-model.trim="editPasswordForm.rePassword" auto-complete="off">
                <el-button slot="append" :icon="showPass?'el-icon-more':'el-icon-view'" @click="showPass = !showPass"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editPasswordFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editPasswordSubmit" :loading="editLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 设置密码界面 end -->
    </el-row>
</template>

<script>
import sessionStore from 'store';
import { defaultAvatar } from '@/api/commonConfig.json';
import { editPassword } from '@/api/api';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data () {
    const validatePass2 = (rule, value, callback) => {
      if (value !== this.editPasswordForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      sysUserName: '',
      sysUserAvatar: '',
      showPass: false,
      editPasswordFormVisible: false,
      editPasswordFormRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: '请重复输入新密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      editPasswordForm: {
        oldPassword: '',
        password: '',
        rePassword: ''
      },
      editLoading: false
    };
  },
  computed: {
    ...mapGetters({
      checkAuth: 'checkAuth',
      isSafe: 'isSafe',
      isAgent: 'isAgent'
    })
  },
  methods: {
    ...mapMutations(['checkPass']),
    /**
     * @description 登出
     */
    logOff () {
      this.logout({
        vm: this,
        confirm: true
      });
    },
    // 打开修改弹窗
    handleUpdatePassword () {
      this.editPasswordFormVisible = true;
      this.editPasswordForm = {
        oldPassword: '',
        password: '',
        rePassword: ''
      };
    },
    editPasswordSubmit () {
      this.$refs.editPasswordForm.validate(valid => {
        if (valid) {
          this.$confirm('确定要修改当前密码?', '提示', {
            type: 'warning'
          }).then(
            data => {
              if (!data) return;
              this.editPasswordFormVisible = false;
              editPassword({
                oldPassword: this.editPasswordForm.oldPassword,
                password: this.editPasswordForm.password
              }).then(res => {
                if (res) {
                  this.$message.success({
                    message: '密码修改成功，请重新登录'
                  });
                  sessionStore.clearAll();
                  this.$router.push('/login');
                }
              });
            },
            () => {
              this.$message.info('取消修改密码');
            }
          );
        } else {
          this.$message.warning('密码填写错误');
        }
      });
    },
    // 退出登录
    logout () {
      var _this = this;
      this.$confirm('确认退出吗?', '提示', {
        // type: 'warning'
      })
        .then(() => {
          // sessionStore.clearAll();
          _this.$router.push('/login');
        })
        .catch(() => {});
    }
  },
  mounted () {
    const me = sessionStore.get('me');
    if (me) {
      this.sysUserName = me.basic.name || '';
      this.sysUserAvatar = me.basic.avatar || defaultAvatar;
    }
    this.checkPass();
    if (!this.isSafe) {
      this.$confirm('当前账号的密码可能存在安全隐患, 请尽快修改?', '提示', {
        confirmButtonText: '我知道了',
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      });
    }
  }
};
</script>
